const adminRouter = [
	{
		path: '/admin',
		meta: { requiresAdmin: true },
		children: [
			{
				path: '',
				name: 'Admin',
				redirect: '/admin/user',
			},
			{
				path: 'user',
				name: 'User',
				children: [
					{
						path: ':userUid',
						name: 'UserDetail',
						component: () => import('../template/BasicTemplate.vue'),
					},
				],
				component: () => import('../template/BasicTemplate.vue'),
			},
			{
				path: 'role',
				name: 'Role',
				component: () => import('../template/BasicTemplate.vue'),
			},
			{
				path: 'department',
				name: 'Department',
				component: () => import('../template/BasicTemplate.vue'),
			},
			{
				path: 'license',
				name: 'License',
				component: () => import('../template/BasicTemplate.vue'),
			},
			{
				path: 'audit',
				name: 'Audit',
				component: () => import('../template/BasicTemplate.vue'),
			},
		],
		component: () => import('../template/BasicTemplate.vue'),
	},
]

export default adminRouter
